'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import programBonuses from '@/data/programBonuses';

export default function BonusesSection() {
  const [bonusData, setBonusData] = useState(null);
  const pathname = usePathname();

  useEffect(() => {
    // Extract the slug based on the path pattern
    let slug;
    const pathParts = pathname.split('/').filter(part => part);
    
    // Check if it's a workshop path
    if (pathParts[0] === 'workshops') {
      // For workshop paths, use format "workshops/[slug]"
      slug = `workshops/${pathParts[1]}`;
    } else {
      // For regular paths, just use the last part as the slug
      slug = pathParts[pathParts.length - 1];
    }
    
    // Find the matching program
    const matchingProgram = programBonuses.find(program => program.slug === slug);
    
    if (matchingProgram) {
      setBonusData(matchingProgram);
    } else {
      // Default to first program or null if array is empty
      setBonusData(programBonuses.length > 0 ? programBonuses[0] : null);
    }
  }, [pathname]);

  if (!bonusData || !bonusData.hasBonuses) {
    return null; // Don't render anything if there are no bonuses
  }

  // Calculate grid columns based on number of bonuses
  const getGridCols = () => {
    const count = bonusData.bonuses.length;
    if (count === 1) return "grid-cols-1";
    if (count === 2) return "grid-cols-1 md:grid-cols-2";
    if (count === 3) return "grid-cols-1 md:grid-cols-3";
    return "grid-cols-1 md:grid-cols-2";
  };

  return (
    <div className="w-full mt-16">
      <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-6">
        {bonusData.heading}
      </h2>
      
      <p className="text-[#002726] text-base mb-8">
        {bonusData.description}
      </p>
      
      <div className={`grid ${getGridCols()} gap-6`}>
        {bonusData.bonuses.map((bonus) => (
          <div 
            key={bonus.id}
            className="bg-[#fffaf1] rounded-2xl p-6 border border-[#f5f5f5]"
          >
            <div className="flex items-start mb-4">
              <div className="flex-shrink-0 mt-1 mr-3 text-[#4CAF50]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 13L10 16L17 9" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="12" r="10" stroke="#4CAF50" strokeWidth="2"/>
                </svg>
              </div>
              <h3 className="text-[#002726] text-base md:text-xl font-medium">{bonus.title}</h3>
            </div>
            
            <p className="text-[#002726] ml-9 text-sm md:text-base">
              {bonus.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}